export type UserID = string;
export type AccountID = string;
export type UserRole = "admin" | "user";

export type Invite = {
  id: UserID;
  account_id: AccountID;
  from_email: string;
  to_email: string;
  role: UserRole;
  created_at: string;
  accepted: boolean;
  declined: boolean;
};

export type User = {
  uid: UserID;
  account_id: AccountID;
  email: string;
  role: UserRole;
  signed_up: boolean;
  created_at: string;
  last_active: string;
};

export function userDisplayName(user: User): string {
  if (user.email.endsWith("@freshpaint.io")) {
    return "Freshpaint";
  }

  return user.email;
}
